import { Error404NotFound } from './Error404NotFound.main';

export { Error404NotFound };
